import { env } from "@/env";

export function getAppLocale(locale?: string) {
  if (env.NEXT_PUBLIC_APP_MARKET === "de") {
    return locale;
  }

  return undefined;
}
